<script setup lang="ts">
defineProps({
  canGoBack: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  goBack: {
    type: Function as PropType<() => void>,
    required: true,
  },
})
const productContent = useProductContentStore()
</script>

<template>
  <div class="flex justify-center w-full gap-4">
    <header
      class="top-0 w-[90%] transform overflow-hidden duration-200 transition-all pointer-events-none z-20 flex h-fit max-w-[90em] items-center justify-between gap-4 py-4 md:justify-start"
    >
      <UButtonNew
        class="pointer-events-auto"
        circle
        aria-label="Tilbake til kapittelet"
        theme="white"
        variant="filled"
        :to="productContent.activeSubject?.frontendHref"
      >
        <template #prepend>
          <u-icon name="minimize" />
        </template>
      </UButtonNew>
      <UButtonNew
        v-if="canGoBack"
        class="pointer-events-auto"
        pill
        theme="white"
        variant="filled"
        @click="goBack"
      >
        <template #prepend>
          <u-icon name="arrow-up" size="sm" />
        </template>
        Forrige
      </UButtonNew>
    </header>
  </div>
</template>
